import { getLocaleUrl, pushEvent } from "@wbly/common";
import type { DataLayer } from "@wbly/common";

export function triggerEvent(
  destination: "preview" | "formats" | "add-ons",
  productSlug: string
) {
  if (destination === "preview") {
    pushEvent(
      window.dataLayer as DataLayer[],
      "CartV3",
      "edit_item",
      `${productSlug}`
    );
  }
  if (destination === "formats") {
    pushEvent(
      window.dataLayer as DataLayer[],
      "CartV3",
      "edit_format",
      `${productSlug}`
    );
  }
  if (destination === "add-ons") {
    pushEvent(
      window.dataLayer as DataLayer[],
      "CartV3",
      "add_extras",
      `${productSlug}`
    );
  }
}

/**
 * Localised URL for specific cart action destinations (e.g. "formats", "add-ons")
 */
export function getActionLocaleUrl({
  marketplace,
  destination,
  productSlug,
  itemId,
}: {
  marketplace: string;
  destination: "preview" | "formats" | "add-ons";
  productSlug: string;
  itemId: number;
}) {
  return getLocaleUrl(
    marketplace,
    `/personalized-products/${productSlug}/edit/${destination}/cart/${itemId}`
  );
}
